import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IShiftInvalidator, 'IShiftInvalidator', VOID, VOID, VOID, [1, 0]);
initMetadataForInterface(IShiftAccessor, 'IShiftAccessor');
initMetadataForInterface(IShiftCompositeAccessor, 'IShiftCompositeAccessor');
initMetadataForInterface(IShiftMutator, 'IShiftMutator', VOID, VOID, VOID, [1, 2]);
//endregion
function IShiftInvalidator() {
}
function IShiftAccessor() {
}
function IShiftCompositeAccessor() {
}
function IShiftMutator() {
}
//region block: exports
export {
  IShiftAccessor as IShiftAccessor1pahto1t0k4qo,
  IShiftCompositeAccessor as IShiftCompositeAccessor1yspg8epnn0zc,
  IShiftMutator as IShiftMutator12aals7g8731k,
  IShiftInvalidator as IShiftInvalidator3ba6keaeoutnl,
};
//endregion

